<template>
  <div class="report-info" v-show="visible"
    @wheel.stop="handleWheel"
    @mouseenter="$emit('diableMapDragAndZoom')"
    @mouseleave="$emit('enableMapDragAndZoom')"
  >
    <!-- 固定的头部容器，包含关闭按钮和标题栏 -->
    <div class="header-container" 
        @mousedown="startDrag"
        @mousemove="handleDrag"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
    >
      <!-- 关闭按钮 -->
      <button class="close-button" @click="handleClose">×</button>
      
      <!-- 标题栏 -->
      <div class="report-header">
        <h3>统计报表</h3>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="report-content">
        <!-- 添加参数区 -->
        <div class="parameter-section">
            <!-- 第1组单选按钮：全部/非粮化/非农化 -->
            <div class="radio-group">
                <label>问题类型：</label>
                <el-radio-group v-model="selectedType">
                  <el-radio label="全部" value="all">全部</el-radio>
                  <el-radio label="非粮化" value="flh">非粮化</el-radio>
                  <el-radio label="非农化" value="fnh">非农化</el-radio>
                </el-radio-group>
            </div>
            <div class="radio-group">
                <label>空间位置：</label>
                <el-radio-group v-model="selectedKjwz">
                  <el-radio label="全部" value="all">全部</el-radio>
                  <el-radio label="永农" value="yn">永农</el-radio>
                  <el-radio label="储备区" value="cbq">储备区</el-radio>
                </el-radio-group>
            </div>
            
            <!-- 第2组单选按钮：当日/本周/本月/制定日期 -->
            <div class="radio-group">
                <label>日期范围：</label>
                <!-- 日期选择组件 -->
                <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="YYYY/MM/DD"
                    value-format="YYYY/MM/DD"
                    style="width: 250px;"
                    ></el-date-picker>
                <label>至</label>
                <!-- 日期选择组件 -->
                <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="YYYY/MM/DD"
                    value-format="YYYY/MM/DD"
                    style="width: 250px;"
                    ></el-date-picker>
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button type="primary" @click="handleCurrDayReport">当日报表</el-button>
            </div>
        </div>
        <div class="statistics-section">
            <!-- 统计数据 -->
             <div style="width: 63%;">
                <div class="title-container">
                    <h2 class="modern-title">截止当前图斑整改统计</h2>
                </div>
                <div class="report-statistics">
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.totalCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.totalArea.toFixed(2) }}亩</span>
                        <span class="stat-label">总任务量</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.ytjCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.ytjArea.toFixed(2) }}亩</span>
                        <span class="stat-label">镇街提交</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.dshCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.dshArea.toFixed(2) }}亩</span>
                        <span class="stat-label">审核中</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.ytgCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.ytgArea.toFixed(2) }}亩</span>
                        <span class="stat-label">已通过</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.wtgCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.wtgArea.toFixed(2) }}亩</span>
                        <span class="stat-label">未通过</span>
                    </div>
                </div>
             </div>
             <div style="width: 37%;">
                <div class="title-container">
                    <h2 class="modern-title">阶段图斑整改统计({{startDate}}至{{endDate}})</h2>
                </div>
                <div class="report-statistics">
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.jdYtjCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.jdYtjArea.toFixed(2) }}亩</span>
                        <span class="stat-label">阶段提交</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.jdYtgCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.jdYtgArea.toFixed(2) }}亩</span>
                        <span class="stat-label">阶段通过</span>
                    </div>
                    <div class="stat-item">
                        <span class="stat-number">{{ reportData.sumData.jdWtgCount }}个</span>
                        <span class="stat-number">{{ reportData.sumData.jdWtgArea.toFixed(2) }}亩</span>
                        <span class="stat-label">阶段未通过</span>
                    </div>
                </div>
             </div>
        </div>
      
      
      <!-- 状态分布图表 -->
      <div class="chart-container">
        <div class="title-container">
            <h2 class="modern-title">简报</h2>
        </div>
        <div class="statistics-section">
            <div class= "chart-container" style="width: 50%;">
                <div class="progress-container" style="display: flex;">
                    <span>整体已提交</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.ytjPercent" :color="'green'"/>
                </div>
                <div class="progress-container" style="display: flex;">
                    <span>整体审核中</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.dshPercent" :color="'rgb(255, 165, 0)'"/>
                </div>
                <div class="progress-container" style="display: flex;">
                    <span>整体已通过</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.ytgPercent" :color="'green'"/>
                </div>
                <div class="progress-container" style="display: flex;">
                    <span>整体未通过</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.wtgPercent" :color="'red'"/>
                </div>

                <div class="progress-container" style="display: flex;">
                    <span>阶段已提交</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.jdYtjPercent" :color="'green'"/>
                </div>
                <div class="progress-container" style="display: flex;">
                    <span>阶段已通过</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.jdYtgPercent" :color="'green'"/>
                </div>
                <div class="progress-container" style="display: flex;">
                    <span>阶段未通过</span><el-progress style="width: 80%;" :text-inside="true" :stroke-width="26" :percentage="reportData.sumData.jdWtgPercent" :color="'red'"/>
                </div>
            </div>
            <div style="width: 50%;">
                <textarea class="simple-textarea" :value="reportData.message">
                    
                </textarea>
            </div>
        </div>
      </div>
      
      <!-- 详细列表 -->
      <div class="report-detail">
        <div class="title-container">
            <h2 class="modern-title">{{reportData.title}}</h2>
        </div>
        <el-table 
            :data="reportData.data" 
            show-summary
            :summary-method="getSummaries"
            border 
            style="width: 100%"
            v-loading="loading"
            element-loading-text="加载中..."
            >
            <el-table-column label="序号" :fixed="'left'" :width="60" align="center">
            <template #default="scope">
                {{ scope.$index + 1 }}
            </template>
            </el-table-column>
            <!-- 镇街名称列 -->
            <el-table-column prop="ZJ" label="镇街" width="120" align="center" :fixed="'left'"/>
            
            <el-table-column label="截止当前统计数据" align="center">
                <!-- 总计数据列 -->
                <el-table-column prop="totalCount" label="任务总数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.totalCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="totalArea" label="任务总面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.totalArea) }}
                    </template>
                </el-table-column>
                
                <!-- 已提交数据列 -->
                <el-table-column prop="ytjCount" label="已提交数量" width="90" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.ytjCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="ytjArea" label="已提交面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.ytjArea) }}
                    </template>
                </el-table-column>
                
                <!-- 待审核数据列 -->
                <el-table-column prop="dshCount" label="审核中数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.dshCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="dshArea" label="审核中面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.dshArea) }}
                    </template>
                </el-table-column>
                
                <!-- 已通过数据列 -->
                <el-table-column prop="ytgCount" label="已通过数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.ytgCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="ytgArea" label="已通过面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.ytgArea) }}
                    </template>
                </el-table-column>
                
                <!-- 未通过数据列 -->
                <el-table-column prop="wtgCount" label="未通过数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.wtgCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="wtgArea" label="未通过面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.wtgArea) }}
                    </template>
                </el-table-column>
            </el-table-column>
            
            <el-table-column label="阶段统计数据" align="center">
                <!-- 阶段数据列 -->
                <el-table-column prop="jdYtjCount" label="已提交数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.jdYtjCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="jdYtjArea" label="已提交面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.jdYtjArea) }}
                    </template>
                </el-table-column>
                <el-table-column prop="jdYtgCount" label="已通过数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.jdYtgCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="jdYtgArea" label="已通过面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.jdYtgArea) }}
                    </template>
                </el-table-column>
                <el-table-column prop="jdWtgCount" label="未通过数量" width="80" align="center">
                    <template #default="scope">
                        {{ formatCount(scope.row.jdWtgCount) }}
                    </template>
                </el-table-column>
                <el-table-column prop="jdWtgArea" label="未通过面积" width="80" align="center">
                    <template #default="scope">
                    {{ formatArea(scope.row.jdWtgArea) }}
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
      </div>
      
      <!-- 操作按钮 -->
      <div class="report-actions">
        <button class="btn btn-primary" @click="exportReport">导出统计报表</button>
        <button class="btn btn-primary" @click="exportRecord">导出当前台账</button>
        <button  v-if="this.roleType == 'GBK'" class="btn btn-primary" @click="exportShapefile">导出Shape全文件</button>
      </div>
    </div>
  </div>
</template>

<script>
// 首先确保已导入必要的库
import * as XLSX from 'xlsx';


export default {
  name: 'ReportInfo',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    roleType:{ //用户角色类型
      type:String,
      default:'',
    },
    reportData: {
      type: Object,
      default: () => ({
        title:'',
        data:[]
      })
    },
  },
  data() {
    return {
      isDragging: false,
      startX: 0,
      startY: 0,
      offsetX: 0,
      offsetY: 0,
      // 统计数据
      totalCount: 0,
      pendingCount: 0,
      completedCount: 0,
      
      // 报表列表数据
      reportList: [],
      // 筛选参数
      selectedType: 'all',
      selectedKjwz: 'all',
      startDate: '',
      endDate: '',
    }
  },  
  methods: {
    startDrag(event) {
      event.stopPropagation();
      this.isDragging = true;
      this.startX = event.clientX;
      this.startY = event.clientY;
      if (this.$el) {
        this.offsetX = this.$el.offsetLeft;
        this.offsetY = this.$el.offsetTop;        
        document.addEventListener('mousemove', this.drag);
        document.addEventListener('mouseup', this.stopDrag);
      }
    },
    drag(event) {
      event.stopPropagation();
      if (this.isDragging && this.$el) {
        const dx = event.clientX - this.startX;
        const dy = event.clientY - this.startY;
        if (this.$el.style) {
          this.$el.style.left = `${this.offsetX + dx}px`;
          this.$el.style.top = `${this.offsetY + dy}px`;
        }
      }
    },
    stopDrag() {
      this.isDragging = false;
      document.removeEventListener('mousemove', this.drag);
      document.removeEventListener('mouseup', this.stopDrag);      
    },
    // 关闭面板
    handleClose() {
      this.$emit('close');
    },

    handleQuery() {
      this.refreshData();
    },
    handleCurrDayReport() {
      this.$emit('showChartData', this.startDate);
    },
    // 表格摘要计算方法
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        
        columns.forEach((column, index) => {
        // 第一列显示"合计"文字
        if (index === 0) {
            sums[index] = '';
            return;
        }
        if (index === 1) {
            sums[index] = '合计';
            return;
        }
        
        // 提取需要汇总的数值列
        const values = data.map(item => {
            // 根据您的字段名调整这些条件
            if (column.property === 'totalCount' || 
                column.property === 'totalArea' || 
                column.property === 'ytjCount' || 
                column.property === 'ytjArea' ||
                column.property === 'dshCount' ||
                column.property === 'dshArea' ||
                column.property === 'wtgCount' ||
                column.property === 'wtgArea' ||
                column.property === 'ytgCount' ||
                column.property === 'ytgArea' ||
                column.property === 'jdYtjCount' ||
                column.property === 'jdYtjArea' ||
                column.property === 'jdYtgCount' ||
                column.property === 'jdYtgArea' ||
                column.property === 'jdWtgCount' ||
                column.property === 'jdWtgArea') {
            return parseFloat(item[column.property]) || 0;
            }
            return 0;
        });
        
        // 计算总和
        if (!values.every(value => isNaN(value))) {
            // 对于面积类字段保留2位小数
            if (column.property === 'totalArea' || 
                column.property === 'ytjArea' ||
                column.property === 'dshArea' ||
                column.property === 'wtgArea' ||
                column.property === 'ytgArea' ||
                column.property === 'jdYtjArea' ||
                column.property === 'jdYtgArea' ||
                column.property === 'jdWtgArea') {
            sums[index] = values.reduce((prev, curr) => {
                const value = parseFloat(curr) || 0;
                return prev + value;
            }, 0).toFixed(2);
            } else {
            // 对于数量类字段直接求和
            sums[index] = values.reduce((prev, curr) => {
                const value = parseFloat(curr) || 0;
                return prev + value;
            }, 0);
            }
        } else {
            sums[index] = '-';
        }
        });
        
        return sums;
    },
    // 1. 首先在exportToExcel方法中确保tableData是有效的数组
    exportToExcel() {
      const wtlx = this.selectedType;
      const kjwz = this.selectedKjwz;
      let wtlxStr = wtlx === 'flh' ? `(非粮化)` : 
                wtlx === 'fnh' ? `(非农化)` : '';  
      let kjwzStr = kjwz === 'yn' ? `(永农)` : 
                kjwz === 'cbq' ? `(储备区)` : '';
      const dateStr = this.getToday(2);
      const filename = `统计报表_${dateStr}${wtlxStr}${kjwzStr}.xlsx`;
      const title = `耕地保护整改进度报表(截止${this.startDate})`;
      const jdTitle = `阶段统计情况(${this.startDate}至${this.endDate})`;
      let excelData = [];
      let head = [title,'','','','','','','','','','','','','','','','',''];
      let head1 = ['序号','镇街','截止当前统计情况','','','','','','','','','',jdTitle,'','','','',''];
      let head2 = ['','','任务总数量','任务总面积','已提交数量','已提交面积','审核中数量','审核中面积','已通过数量','已通过面积','未通过数量','未通过面积','已提交数量','已提交面积','已通过数量','已通过面积','未通过数量','未通过面积'];
      excelData.push(head);
      excelData.push(head1);
      excelData.push(head2);
      this.reportData.data.forEach((item,index)=>{
        let row = [];
        row.push(index + 1);
        row.push(item['ZJ']);
        row.push(this.formatCount(item['totalCount']));
        row.push(this.formatArea(item['totalArea']));
        row.push(this.formatCount(item['ytjCount']));
        row.push(this.formatArea(item['ytjArea']));
        row.push(this.formatCount(item['dshCount']));
        row.push(this.formatArea(item['dshArea']));
        row.push(this.formatCount(item['wtgCount']));
        row.push(this.formatArea(item['wtgArea']));
        row.push(this.formatCount(item['ytgCount']));
        row.push(this.formatArea(item['ytgArea']));
        row.push(this.formatCount(item['jdYtjCount']));
        row.push(this.formatArea(item['jdYtjArea']));
        row.push(this.formatCount(item['jdYtgCount']));
        row.push(this.formatArea(item['jdYtgArea']));
        row.push(this.formatCount(item['jdWtgCount']));
        row.push(this.formatArea(item['jdWtgArea']));
        excelData.push(row);
      })
      {
        let row = [];
        row.push('');
        row.push(this.reportData.sumData['label']);
        row.push(this.formatCount(this.reportData.sumData['totalCount']));
        row.push(this.formatArea(this.reportData.sumData['totalArea']));
        row.push(this.formatCount(this.reportData.sumData['ytjCount']));
        row.push(this.formatArea(this.reportData.sumData['ytjArea']));
        row.push(this.formatCount(this.reportData.sumData['dshCount']));
        row.push(this.formatArea(this.reportData.sumData['dshArea']));
        row.push(this.formatCount(this.reportData.sumData['wtgCount']));
        row.push(this.formatArea(this.reportData.sumData['wtgArea']));
        row.push(this.formatCount(this.reportData.sumData['ytgCount']));
        row.push(this.formatArea(this.reportData.sumData['ytgArea']));
        row.push(this.formatCount(this.reportData.sumData['jdYtjCount']));
        row.push(this.formatArea(this.reportData.sumData['jdYtjArea']));
        row.push(this.formatCount(this.reportData.sumData['jdYtgCount']));
        row.push(this.formatArea(this.reportData.sumData['jdYtgArea']));
        row.push(this.formatCount(this.reportData.sumData['jdWtgCount']));
        row.push(this.formatArea(this.reportData.sumData['jdWtgArea']));
        excelData.push(row);
      }
      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      const merges = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 17 } },
        { s: { r: 1, c: 0 }, e: { r: 2, c: 0 } },
        { s: { r: 1, c: 1 }, e: { r: 2, c: 1 } },
        { s: { r: 1, c: 2 }, e: { r: 1, c: 11 } },
        { s: { r: 1, c: 12 }, e: { r: 1, c: 17 } },
      ];
      ws['!merges'] = merges;
      // 定义居中和带边框的样式
        const style = {
            alignment: {
                horizontal: 'center', // 水平居中
                vertical: 'center',   // 垂直居中
                wrapText: false       // 是否自动换行
            },
            border: {
                top: { style: 'thin' },    // 上边框
                bottom: { style: 'thin' }, // 下边框
                left: { style: 'thin' },   // 左边框
                right: { style: 'thin' }   // 右边框
            }
        };
  
        // 方法1：遍历所有单元格应用样式
        for (const cellAddress in ws) {
            if (cellAddress.startsWith('!')) continue;            
            // 应用样式到单元格
            ws[cellAddress].s = style;
        }
        if(ws['A1']){
          ws['A1'].s = style;
        }
        if(ws['A2']){
          ws['A2'].s = style;
        }
        if(ws['B2']){
          ws['B2'].s = style;
        }
        if(ws['C2']){
          ws['C2'].s = style;
        }
        if(ws['M2']){
          ws['M2'].s = style;
        }
      
      XLSX.utils.book_append_sheet(wb,ws,'Sheet1');
      XLSX.writeFile(wb,filename);
    },
    
    formatArea(area) {
      if (!area && area !== 0) return '-';
      if (area < 0.01) return '-';
      return Number(area).toFixed(2);
    },
    formatCount(count) {
      if (!count || count < 1) return '-';
      return Number(count).toFixed(0);
    },
    exportShapefile() {
      const dateStr = this.getToday(2);      
      // 导出逻辑
      this.$emit('exportToShpFile',{
        fileName: `图斑矢量_${dateStr}`
      });
    },
    // 导出报表
    exportReport() {
      // 导出逻辑
      this.exportToExcel();
    },
    // 导出报表
    exportRecord() {
      // 导出逻辑
      const dateStr = this.getToday(2);
      const wtlx = this.selectedType;
      const kjwz = this.selectedKjwz;
      let wtlxStr = wtlx === 'flh' ? `(非粮化)` : 
                wtlx === 'fnh' ? `(非农化)` : '';  
      let kjwzStr = kjwz === 'yn' ? `(永农)` : 
                kjwz === 'cbq' ? `(储备区)` : '';
      this.$emit('getRecordDataAndToExcel', {
        fileName: `耕地保护问题记录_${dateStr}${wtlxStr}${kjwzStr}.xlsx`,
        wtlx: this.selectedType,
        kjwz: this.selectedKjwz
      });
    },
    getToday(lx){ //0:开始时间 1:结束时间 
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补前导零
        const day = String(currentDate.getDate()).padStart(2, '0'); // 补前导零
        if(lx === 0){
            return `${year}/${month}/${day}`;
        }else if(lx === 1){
            return `${year}/${month}/${day} 23:59:59`;
        }else{
            return `${year}_${month}_${day}_${currentDate.getHours()}_${currentDate.getMinutes()}_${currentDate.getSeconds()}`;
        }
    },
    // 刷新数据
    refreshData() {
      if(!this.startDate){
        this.startDate = this.getToday(0);
      }
      if(!this.endDate){
        this.endDate = this.getToday(1);
      }
      if(!this.endDate.includes('23:59:59')){
        this.endDate = `${this.endDate} 23:59:59`;
      }

      this.$emit('getReportData', {
        startDate: this.startDate,
        endDate: this.endDate,
        wtlx: this.selectedType,
        kjwz: this.selectedKjwz
      });
    }
  }
}
</script>

<style scoped>
.report-info {
  position: fixed;
  top: 15%;
  left: 15%;
  width: 70%;
  max-height: 80%;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: auto;
}

/* 使用sticky定位的头部容器 */
.header-container {
  position: sticky;
  top: 0;
  background-color: #f5f5f5;
  border-bottom: 1px solid #ddd;
  z-index: 1001;
  display: flex;
  align-items: center;
  height: 50px;
}

.close-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1002;
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  pointer-events: auto;
  background: none;
  border: none;
  padding: 5px;
}

.close-button:hover {
  color: #666;
}

.report-header {
  width: 100%;
  padding: 12px 16px;
}

.report-header h3 {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.report-content {
  padding: 16px;
  overflow-y: auto;
  max-height: calc(100% - 50px);
}

.report-statistics {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 16px;
  background-color: #b0cde8;
  border-radius: 4px;
}

.stat-item {
  text-align: center;  
}

.stat-number {
  display: block;
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 18px;
  font-weight: bold;
  color: #bf5757;
}

.chart-container {
  margin-bottom: 10px;
  background-color: #b0cde8;
}

.chart-container h4 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
}

.chart-placeholder {
  height: 200px;
  background-color: #b0cde8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.chart-placeholder span{
    font-size: 14px;
    font-weight: bold;
    color: #bf5757;
}

.progress-container{
    width: 90%;    
    border-radius: 4px;
    margin: 10px;
    gap: 10px;
}

::v-deep .el-progress-bar__outer {
  background-color: #b3afb2  !important;; /* 这是新的未完成部分颜色，您可以根据需要修改 */
}

.progress-container span{
    font-size: 14px;
    font-weight: bold;
    color: #343bbc;
}

.simple-textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: vertical;
  font-size: 14px;
  color: #333;
  height: 250px;
  background-color: #b0cde8;
}

.report-detail {
  margin-bottom: 12px;
}

.report-detail h4 {
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 14px;
  color: #333;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
}

.detail-table th,
.detail-table td {
  padding: 8px;
  border: 1px solid #ddd;
  text-align: left;
}

.detail-table th {
  background-color: #f5f5f5;
  font-weight: bold;
  color: #333;
}

.report-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.btn {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary {
  background-color: #409EFF;
  border-color: #409EFF;
  color: white;
}

.btn-primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.btn-default:hover {
  background-color: #f5f5f5;
}

.parameter-section {
  padding: 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin-top: 5px;  
  gap: 20px;
}

.statistics-section {
  padding: 15px;
  background-color: #f5f5f5;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin-top: 5px;  
  gap: 20px;
  display: flex;
}

.radio-group {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.radio-group > label:first-child {
  font-weight: 600;
  color: #333;
  margin-right: 10px;
}

.date-picker-group {
  display: flex;
  align-items: center;
}

.title-container {
  padding: 5px 0;
  border-bottom: 2px solid #3498db;
  margin-bottom: 5px;  
}

.modern-title {
  font-size: 18px;
  font-weight: 600;
  color: #34495e;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.modern-title ::after{
  content: '';
  position: absolute;
  bottom: -17px;
  left: 0;
  width: 50%;
  height: 2px;
  background-color: #e74c3c;
}

.el-table {
  overflow: auto;
}

/* 移除表体和表尾的内部滚动条 */
.el-table__body-wrapper,
.el-table__footer-wrapper {
  overflow-x: visible !important;
}

/* 确保表头不随内容滚动 */
.el-table__header-wrapper {
  overflow-x: visible !important;
}

/* 修复汇总行可能出现的样式问题 */
.el-table__footer-wrapper {
  border-top: 1px solid #ebeef5;
}

/* 确保表格宽度正确计算 */
.el-table__body,
.el-table__footer {
  width: 100%;
  table-layout: auto;
}

/* 美化滚动条（可选） */
.el-table::-webkit-scrollbar {
  height: 8px;
}

.el-table::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.el-table::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 4px;
}

.el-table::-webkit-scrollbar-thumb:hover {
  background: #909399;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .report-info {
    width: 95%;
    left: 2.5%;
  }
  
  .report-statistics {
    flex-direction: column;
    gap: 12px;
  }
  
  .detail-table {
    font-size: 12px;
  }
  
  .detail-table th,
  .detail-table td {
    padding: 6px;
  }
}
</style>